import { Tag } from 'antd';

/**
 * Status badge for the SSO Configuration tab header.
 *
 * Three states:
 *  - not configured → neutral "Not Configured" (no config row exists yet)
 *  - enabled        → green "SSO Enabled"
 *  - disabled       → orange "SSO Disabled" (config exists but toggled off)
 */
export interface SsoStatusBadgeProps {
  configured: boolean;
  enabled?: boolean;
}

export const SsoStatusBadge: React.FC<SsoStatusBadgeProps> = ({ configured, enabled }) => {
  if (!configured) return <Tag>Not Configured</Tag>;
  if (enabled) return <Tag color="green">SSO Enabled</Tag>;
  return <Tag color="orange">SSO Disabled</Tag>;
};
